<template>
  <div class="availability">
    <div class="availability-table">
      <span class="availability-title">CURRENT AVAILABILITY</span>
      <div class="table-container" role="table" aria-label="Destinations">
        <div class="flex-table headers" role="rowgroup">
          <div class="flex-row first" role="columnheader">Unit</div>
          <div class="flex-row" role="columnheader">Bed</div>
          <div class="flex-row" role="columnheader">Bath</div>
          <div class="flex-row" role="columnheader">Int.SqFt</div>
          <div class="flex-row" role="columnheader">Ext.SqFt</div>
          <div class="flex-row" role="columnheader">CC</div>
          <div class="flex-row" role="columnheader">RET</div>
          <div class="flex-row" role="columnheader">Price</div>
          <div class="flex-row flex-row-mobile" role="columnheader">Floorplan</div>
        </div>
        <div class="flex-table row" role="rowgroup" @click.stop="openDocument(unit.floorplan)" v-for="unit in units" :key="unit.id">
          <div class="flex-row first" role="cell"><span class="flag-icon flag-icon-gb"></span>{{ unit.name }}</div>
          <div class="flex-row" role="cell">{{ unit.bedroom }}</div>
          <div class="flex-row" role="cell">{{ unit.bathroom }}</div>
          <div class="flex-row" role="cell">{{ unit.int_sqft }}</div>
          <div class="flex-row" role="cell">{{ unit.ext_sqft ? unit.ext_sqft : '-' }}</div>
          <div class="flex-row" role="cell">{{ unit.cc }}</div>
          <div class="flex-row" role="cell">{{ unit.tax }}</div>
          <div class="flex-row" role="cell">{{ unit.price }}</div>
          <div class="flex-row flex-download flex-row-mobile" role="cell" @click.prevent="openNewDocument(unit.floorplan)">
            <img class="download-image" src="../assets/availability/download.svg" alt="download">
          </div>
        </div>
      </div>
    </div>
    <div class="availability__view">
      <img src="../assets/availability/availability.jpg" alt="Availability" class="availability__view--image">
    </div>
  </div>
</template>

<script>
    // eslint-disable-next-line no-unused-vars
    const dataLayer = window.dataLayer || [];
    dataLayer.push({
        'event': 'PageView',
        'pagePath': '/availability',
        'pageTitle': 'Parker West | Availability'
    })
  export default {
    name: "Availability",
    data: () => ({

    }),
      metaInfo: {
          // Define meta tags here.
          titleTemplate: '%s ← Availability',
          meta: [
              {name: 'description', content: 'Availability penthouse page'}
          ],
          link: [
              {rel: 'canonical', href: 'http://test.parkerwest.com/'}
          ]
      },
    computed: {
        units() {
            return window.units;
        }
    },
      created() {
          if(window.innerWidth <= 600) {
              let myMain = document.getElementsByClassName('app-main')[0];
              myMain.scrollTop = 0;
          }
      },
      methods: {
      openDocument(fp) {
        if ("ontouchstart" in document.documentElement) {
          window.open(fp, '_blank')
          return;
        }
        if (window.innerWidth < 769) {
          window.open(fp, '_blank')
          return;
        }
      },
      openNewDocument(fp) {
        if (window.innerWidth > 600) {
          window.open(fp, '_blank')
          return;
        }
      }
    }
  }
</script>

